export enum PaymentMethod {
  BankAccount = '1',
  CreditCard = '2'
}

export enum PaymentProfile {
  WINDCAVE = '1',
  CYBERSOURCE = '2'
}

export enum PaymentInstrumentType {
  PAYMENT_CARD = '1',
  PAYMENT_CARD_TOKEN = '3'
}

export enum CreditCardNetwork {
  MASTERCARD = '4',
  VISA = '5',
  AMEX = '6',
  NONE = ''
}

export enum CybersourceCreditCardNetwork {
  VISA = '1',
  MASTERCARD = '2',
  AMEX = '6',
  NONE = ''
}

export const PaymentProfileMap: { [key in PaymentInstrumentType]: PaymentProfile } = {
  [PaymentInstrumentType.PAYMENT_CARD]: PaymentProfile.WINDCAVE,
  [PaymentInstrumentType.PAYMENT_CARD_TOKEN]: PaymentProfile.CYBERSOURCE
};

export enum PaymentFlow {
  Normal = 1,
  PayInFull = 2
}
